<template>
  <div id="app">
    <div class="pages-view">
      <router-view/>


      <a href="#" class="go-to-top">
        <b-button type="is-light" @click="addModalShow = true" icon-left="arrow-up" />
      </a>
    </div>
  </div>
</template>

<script>
import store from './store.js'

export default {
  async beforeCreate() {
    await store.dispatch('whoami')
  }
}
</script>

<style lang="scss">
.go-to-top {
  position: fixed;
  bottom: 20px;
  right: 20px;
}

.add-fixed-button {
  position: fixed;
  bottom: 20px;
  right: 70px;

  > * {
    margin-left: 16px;
  }

  > *:first-child {
    margin-left: 0;
  }
}
</style>



